/* @jsx h */

import { TablePayment } from "@app/vue/pages/Tables/payments/TablePayment";
import { printTableBill } from "@app/vue/pages/Tables/useTableDetailsActions";

import { useShop } from "@app/vue/providers/ShopConnection";
import { useToast } from "@app/vue/providers/Toast";
import { TableStatus } from "@lemmonhq/types";
import { useLocalization } from "@lemmonhq/uikit";
import { defineComponent, h, onMounted, ref } from "vue";
import { RouterLink } from "vue-router";

export type TableToolbarProps = {
  tableStatus: TableStatus;
  onPayment?: Function;
};
export const TableToolbar = defineComponent<TableToolbarProps>({
  name: "TableOverview",
  props: ["tableStatus", "onPayment"],
  setup(props) {
    const fetch = async () => {};
    onMounted(() => {
      fetch();
    });
    const { t } = useLocalization();
    const showPaymentModal = ref(false);
    const isPrinting = ref(false);
    const shop = useShop();
    const toast = useToast();
    return () => {
      const { tableStatus } = props;
      const isBusy = tableStatus?.table.is_busy;

      return (
        <>
          <div class="flex flex-col">
            <div class="flex gap-2 p-4  rounded-lg">
              {isBusy ? (
                <>
                  <button
                    onClick={async (e) => {
                      e.preventDefault();
                      try {
                        isPrinting.value = true;
                        await printTableBill(props.tableStatus, shop, toast);
                      } catch (e) {
                        console.error("Failed to print bill:", e);
                      } finally {
                        isPrinting.value = false;
                      }
                    }}
                    class="btn btn-secondary"
                  >
                    <span class="flex justify-center items-center">
                      <span class="material-symbols-outlined mr-0.5">
                        print
                      </span>
                    </span>
                  </button>
                  <RouterLink
                    class="btn btn-accent flex-1"
                    to={`/app/pos?tableId=${tableStatus.table.id}`}
                  >
                    {() => (
                      <span class="flex justify-center items-center gap-2">
                        <span class="material-symbols-outlined">
                          add_shopping_cart
                        </span>
                        <span>{t("tables.general.add_button")}</span>
                      </span>
                    )}
                  </RouterLink>
                  <RouterLink
                    class="btn btn-neutral flex-1"
                    to={`/app/orders?tableId=${tableStatus.table.id}`}
                  >
                    {() => (
                      <span class="flex justify-center items-center gap-2">
                        <span class="material-symbols-outlined">
                          order_approve
                        </span>
                        <span>{t("tables.general.orders_button")}</span>
                      </span>
                    )}
                  </RouterLink>
                  <button
                    onClick={() => {
                      showPaymentModal.value = true;
                      console.log("settings", showPaymentModal.value);
                    }}
                    class="btn btn-primary flex-1"
                  >
                    <span class="flex justify-center items-center gap-2">
                      <span class="material-symbols-outlined">credit_card</span>
                      <span>{t("tables.general.pay_button")}</span>
                    </span>
                  </button>
                </>
              ) : (
                <RouterLink
                  class="btn btn-accent col-span-3"
                  to={`/app/pos?tableId=${tableStatus.table.id}`}
                >
                  {() => (
                    <span class="flex justify-center items-center gap-2">
                      <span class="material-symbols-outlined">
                        add_shopping_cart
                      </span>
                      <span>{t("tables.general.add_orders_button")}</span>
                    </span>
                  )}
                </RouterLink>
              )}
            </div>
            {showPaymentModal.value ? (
              <TablePayment
                tableStatus={tableStatus}
                onClose={() => {
                  showPaymentModal.value = false;
                }}
                onSuccess={(closed) => {
                  if (closed) {
                    showPaymentModal.value = false;
                    if (props.onPayment) {
                      props.onPayment();
                    }
                  }
                }}
              />
            ) : null}
          </div>
        </>
      );
    };
  },
});
